export default __webpack_public_path__ + "static/media/kingkong.3bbb5c23.png";